import { HolidayApi } from '../../models/holiday/holiday-api.model';

export interface IHolidayState {
  holidays: HolidayApi[];
  loading: boolean;
  error: string | null;
}

export const initialHolidayState: IHolidayState = {
  holidays: [],
  loading: false,
  error: null,
};
